import CardActionButton from "components/Cards/Card/Actions/Button"
import CardActionCheckbox from "components/Cards/Card/Actions/Checkbox"

import { ComponentProps } from "."
import { Buttons, Checkboxes } from "./styled"

const Actions = ({
  clearListButtonProps,
  isAdmin,
  isEditor,
  loadMoreButtonProps,
  listButtonProps,
  onlyNewProps,
  onlyPresentProps,
  serviceName,
  showFlaggedProps
}: ComponentProps) => (
  <>
    <Buttons>
      <CardActionButton {...listButtonProps} />

      <CardActionButton {...clearListButtonProps} />

      {serviceName === "bluRay" ? (
        <CardActionButton {...loadMoreButtonProps} isOutlined />
      ) : null}
    </Buttons>

    {isAdmin || isEditor ? (
      <Checkboxes>
        <CardActionCheckbox {...onlyNewProps} />

        <CardActionCheckbox {...onlyPresentProps} />

        <CardActionCheckbox {...showFlaggedProps} />
      </Checkboxes>
    ) : null}
  </>
)

Actions.whyDidYouRender = true

export default Actions
